// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"84c78c16","555":"95d725b2"}[chunkId] + ".chunk.css";
};